import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useRole } from '@/hooks/useRole';
import DashboardPage from './DashboardPage';

export default function Dashboard() {
  const location = useLocation();
  const { logout } = useAuth();
  const { isAdmin } = useRole();

  // 获取当前页面标题
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/devices')) return 'Devices';
    if (path.includes('/users')) return 'Users';
    if (path.includes('/settings')) return 'Settings';
    return 'Dashboard';
  };

  return (
    <div className="w-full">
      <DashboardPage />
      
      <footer className="mt-8 text-center text-sm text-gray-500">
        {'Copyright © '}
        <a href="https://splashmepool.com.au/" className="text-primary-600 hover:text-primary-700">
          SplashMe
        </a>{' '}
        {new Date().getFullYear()}
        {'.'}
      </footer>
    </div>
  );
} 